import "./ServiceCard.scss";
import chevRight from "../../assets/icons/chevronRight.svg";
import { useState } from "react";

export default function ServiceCard(props: { content: string; title: string }) {
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <li className={isActive ? "service service--active" : "service"}>
      <h2 className="service__title" onClick={() => setIsActive(!isActive)}>
        {props.title}
      </h2>
      <div
        className="service__container"
        onClick={() => setIsActive(!isActive)}
      >
        <img src={chevRight} alt="Right Arrow" className="service__arrow" />
      </div>
      <p className="service__content">{props.content}</p>
    </li>
  );
}
